import { useI18n } from '@/hooks/useI18n';

export const RouteFallback = () => {
  const { t } = useI18n();
  return (
    <div className="route-fallback" role="status" aria-live="polite">
      {t('common.loading')}
    </div>
  );
};
